export default __webpack_public_path__ + "static/media/chevron-top.faf852ea.svg";